var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpeechWidget = function SvgSpeechWidget(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 69,
    viewBox: "0 0 192 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1086_14160)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 13,
    width: 156,
    height: 52,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.651 34.4939L42.0377 38.9041C42.0001 38.9335 41.9697 38.9712 41.9488 39.0142C41.9279 39.0571 41.917 39.1043 41.917 39.1521C41.917 39.1999 41.9279 39.2471 41.9488 39.29C41.9697 39.333 42.0001 39.3707 42.0377 39.4001L47.651 43.8103C47.86 43.9744 48.1666 43.8259 48.1666 43.5623L48.167 39.1521L48.1666 34.7419C48.1666 34.4783 47.86 34.3298 47.651 34.4939ZM41.7916 33.9958H40.7916C40.7233 33.9958 40.6666 34.0486 40.6666 34.113V44.1912C40.6666 44.2556 40.7233 44.3083 40.7916 44.3083H41.7916C41.86 44.3083 41.9166 44.2556 41.9166 44.1912V34.113C41.9166 34.0486 41.86 33.9958 41.7916 33.9958Z",
    fill: "#C8D1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1094 34.3418L90.4961 38.752C90.4585 38.7814 90.4281 38.8191 90.4072 38.8621C90.3863 38.905 90.3754 38.9522 90.3754 39C90.3754 39.0478 90.3863 39.095 90.4072 39.1379C90.4281 39.1809 90.4585 39.2186 90.4961 39.248L96.1094 43.6582C96.3184 43.8223 96.625 43.6738 96.625 43.4102V34.5898C96.625 34.3262 96.3184 34.1777 96.1094 34.3418ZM102.359 34.3418L96.7461 38.752C96.7085 38.7814 96.6781 38.8191 96.6572 38.8621C96.6363 38.905 96.6254 38.9522 96.6254 39C96.6254 39.0478 96.6363 39.095 96.6572 39.1379C96.6781 39.1809 96.7085 39.2186 96.7461 39.248L102.359 43.6582C102.568 43.8223 102.875 43.6738 102.875 43.4102V34.5898C102.875 34.3262 102.568 34.1777 102.359 34.3418ZM90.25 33.8438H89.25C89.1816 33.8438 89.125 33.8965 89.125 33.9609V44.0391C89.125 44.1035 89.1816 44.1562 89.25 44.1562H90.25C90.3184 44.1562 90.375 44.1035 90.375 44.0391V33.9609C90.375 33.8965 90.3184 33.8438 90.25 33.8438Z",
    fill: "#C8D1DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 30.25C143.168 30.25 139.25 34.168 139.25 39C139.25 43.832 143.168 47.75 148 47.75C152.832 47.75 156.75 43.832 156.75 39C156.75 34.168 152.832 30.25 148 30.25ZM148 46.2656C143.988 46.2656 140.734 43.0117 140.734 39C140.734 34.9883 143.988 31.7344 148 31.7344C152.012 31.7344 155.266 34.9883 155.266 39C155.266 43.0117 152.012 46.2656 148 46.2656Z",
    fill: "#1E4176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.051 38.7483L146.267 34.549C146.221 34.515 146.166 34.4946 146.109 34.4899C146.051 34.4853 145.994 34.4967 145.943 34.5228C145.892 34.549 145.849 34.5888 145.819 34.6379C145.789 34.687 145.773 34.7435 145.773 34.801V43.1994C145.773 43.4553 146.062 43.5998 146.267 43.4514L152.051 39.2522C152.091 39.2234 152.123 39.1855 152.146 39.1417C152.168 39.0979 152.18 39.0494 152.18 39.0002C152.18 38.951 152.168 38.9025 152.146 38.8587C152.123 38.8149 152.091 38.777 152.051 38.7483ZM147.019 41.3655V36.635L150.275 39.0002L147.019 41.3655Z",
    fill: "#1E4176"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1086_14160",
    x: 0,
    y: 0,
    width: 192,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    "in": "SourceAlpha",
    result: "effect1_dropShadow_1086_14160"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.211765 0 0 0 0 0.27451 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1086_14160"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1086_14160",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpeechWidget);
export { ForwardRef as ReactComponent };